import { ChangeDetectorRef, Directive, HostBinding, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({ selector: '[vexContainer]' })
export class ContainerDirective {
	private configService = inject(ConfigService);
	private cd = inject(ChangeDetectorRef);

	@HostBinding('class.container') enabled: boolean;

	constructor() {
		this.configService.config$
			.pipe(
				map((config) => config.boxed),
				distinctUntilChanged(),
				untilDestroyed(this)
			)
			.subscribe((boxed) => {
				this.enabled = boxed;
				this.cd.markForCheck();
			});
	}
}
